<template>
    <NuxtLayout name="default">
        <SmuError
            :title="title"
            :status-code="errorStatus"
            :description="errorMessage"
            :info-box-title="description"
            :info-box-description="instruction"
            :action-text="t('helpers.buttons.dashboard')"
            :action="goToDashboard"
        />
    </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from "nuxt/app";
import { SmuError } from "@smakecloud/smake-ui";

const { t } = useI18n();

const props = defineProps<{
    error: NuxtError;
}>();

const errorStatus = computed(() => props.error.status);

const errorKey = computed(() => {
    return errorStatus.value === undefined
        ? "unknown"
        : String(errorStatus.value);
});

const title = computed(() => {
    return t(`errors.${errorKey.value}.title`);
});

const description = computed(() => {
    return t(`errors.${errorKey.value}.description`);
});

const instruction = computed(() => {
    return t(`errors.${errorKey.value}.instruction`);
});

const errorMessage = computed(() => {
    return t(`errors.${errorKey.value}.message`);
});

const slug = useSlug();

function goToDashboard() {
    return navigateTo({
        name: "slug-dashboard",
        params: { slug: slug.value ?? "" },
    });
}
</script>
